export const sort = (list: number[]): number[] => {
  return list.sort((x, y) => x - y);
};
